'use strict';

module.exports = {
    time: [
        'boundaryMaxArrivalDate',
        'boundaryMinArrivalDate',
        'maxArrivalDate',
        'minArrivalDate',
        'selectedMaxArrivalDate',
        'selectedMaxArrivalDateStr',
        'selectedMinArrivalDate',
        'selectedMinArrivalDateStr',
        'boundaryMaxDepartureDate',
        'boundaryMinDepartureDate',
        'maxDepartureDate',
        'minDepartureDate',
        'selectedMaxDepartureDate',
        'selectedMaxDepartureDateStr',
        'selectedMinDepartureDate',
        'selectedMinDepartureDateStr',
    ],
    stopoverQuantity: [
        'minStops',
        'maxStops',
    ],
    stopoverDuration: [
        'maxStops',
        'minStopDuration',
        'maxStopDuration',
        'boundaryMaxStopDuration',
        'boundaryMinStopDuration',
        'selectedStopDuration',
    ],
    stopoverConnection: [
        'stopoversMetadata',
    ],
    airports: [
        'visibleReturnSameOrigin',
        'visibleDepartSameDestination',
    ],
    airlines: [
        'hasLowCosts',
        'hasTrains',
        'visibleAirlinesAll',
        'visibleLowCostsTrainsAll',
    ],
    flightDuration: [
        'maxTripDuration',
        'minTripDuration',
        'selectedTripDuration',
    ],
};
